import { render, staticRenderFns } from "./QueryList.vue?vue&type=template&id=57201b26&scoped=true"
import script from "./QueryList.vue?vue&type=script&lang=ts"
export * from "./QueryList.vue?vue&type=script&lang=ts"
import style0 from "./QueryList.vue?vue&type=style&index=0&id=57201b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57201b26",
  null
  
)

export default component.exports